import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';
import { StateSelect } from '../StateSelect';

export const Box05_PatientAddress: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">5. PATIENT&apos;S ADDRESS</Typography>
      <Box display="flex" flexDirection="column" gap={1}>
        <Controller
          name="patientAddress.line1"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Address Line 1"
              fullWidth
            />
          )}
        />
        <Controller
          name="patientAddress.line2"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Address Line 2 (Optional)"
              fullWidth
            />
          )}
        />
        <Box display="flex" gap={1}>
          <Controller
            name="patientAddress.city"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="City"
                fullWidth
                sx={{ flex: 1 }}
              />
            )}
          />
          <Controller
            name="patientAddress.state"
            control={control}
            render={({ field, fieldState }) => (
              <StateSelect 
                {...field} 
                size="small" 
                placeholder="State" 
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="patientAddress.zip"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="ZIP"
                sx={{
                  width: '100px',
                  minWidth: '100px',
                  maxWidth: '100px',
                  flex: '0 0 100px',
                }}
              />
            )}
          />
        </Box>
        <Controller
          name="patientAddress.phone"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Phone"
              fullWidth
            />
          )}
        />
      </Box>
    </>
  );
};